import { store } from '@redux/store';
import {selectConfigurationImageResizeService } from 'layout/redux/selectors';

export default function getRandomLifestyleImage(){
    const state = store.getState();
    const irsDomain = selectConfigurationImageResizeService(state);
    const random = Math.random();
    const number = Math.floor(random * 20) + 1;
    return `${irsDomain}/images/Lifestyle/lifestyle_${number}.jpg`;
}